export const environment = {
	adeslas: 'https://www.segurcaixaadeslas.es/',
	apiURL: 'https://segurcaixa-function-dev.azurewebsites.net/api/',
	authSettings: {
		clientId: 'dcb6d892-ebf4-11ec-8ea0-0242ac120002',
		authority: 'https://loginpre.segurcaixaadeslas.es/auth/realms/ssoextpreadeslas-2',
		scope: 'openid token'
	},
	production: false,
	name: 'Default-environment',
	useMock: false,
	dataUrl: false,	
	endpoints: {
		getClient: 'GetClient',
		entranceTrees: 'EntranceTrees',
		getDecisionTree: 'GetDecisionTree',
		getTimesZone: 'GetTimesZone',
		confirmAppointment: 'ConfirmAppointment',
		openClaim: 'OpenClaim',
		sendDocuments: 'SendDocuments'
	},
	languages: ['es', 'ca', 'en'],
	defaultLanguage: 'es'	
};
